import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbTimepickerModule } from '@cmps/ng-bootstrap';
import { CmpsPortalModule } from '@cmps/ng-uikit';

import { DateTimeParserFormatter } from './datetime-parser-formatter';
import { DateTimePickerInput } from './datetime-picker-input.directive';
import { DateTimePickerComponent } from './datetime-picker.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        CmpsPortalModule,
    ],
    declarations: [DateTimePickerInput, DateTimePickerComponent],
    providers: [DateTimeParserFormatter],
    exports: [DateTimePickerInput, DateTimePickerComponent],
})
export class CmpsDateTimePickerModule {}
